import * as React from 'react'
import styled from 'styled-components'
import Error from '../../pages/_error'
import { SAFE_AREA_INSET_TOP } from 'utils/style'

const MainFrame = styled.main(() => ({
  margin: '0 auto',
  paddingTop: SAFE_AREA_INSET_TOP,
  backgroundColor: 'white',
  maxWidth: 600,
  minHeight: '100vh',
}))

const Component = ({ children, statusCode = null, ...props }) => {
  if (statusCode) return <Error statusCode={statusCode} />

  return <MainFrame {...props}>{children}</MainFrame>
}

export default Component
